import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const HomeLoanCalculatorCTA = () => {
  const navigate = useNavigate();
  
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1.05, 
        ease: [0.17, 0.55, 0.55, 1], 
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.section
      className="my-12 px-4 sm:px-6 lg:px-8 text-center"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible" 
      viewport={{ amount: 0.5 }} 
    >
      {/* Main Heading */}
      <motion.h2
        className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4"
        variants={itemVariants}
      >
        Plan Your EMI Before You Buy
      </motion.h2>

      {/* Subheading */}
      <motion.p
        className="text-xl md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto"
        variants={itemVariants}
      >
        Calculate your downpayment and monthly EMI in seconds
      </motion.p>

      {/* CTA Button */}
      <motion.button
        whileHover={{ scale: 1.09, y: -2 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => navigate("/loancalculator")}
        className="inline-block px-8 py-4 text-lg font-bold rounded-full bg-accent text-white hover:bg-primary-700 transition-all duration-300"

        variants={itemVariants}
      >
        Calculate Your EMI
      </motion.button>
    </motion.section>
  );
};

export default HomeLoanCalculatorCTA;
